import { StyleSheet } from 'react-native-unistyles'

import { breakpoints, theme } from '@ui-kit/theme'

type AppBreakpoints = typeof breakpoints
type AppThemes = {
  default: typeof theme
}

declare module 'react-native-unistyles' {
  // eslint-disable-next-line @typescript-eslint/no-empty-object-type
  export interface UnistylesThemes extends AppThemes {}
  // eslint-disable-next-line @typescript-eslint/no-empty-object-type
  export interface UnistylesBreakpoints extends AppBreakpoints {}
}

StyleSheet.configure({
  themes: {
    default: theme,
  },
  breakpoints,
  settings: {
    initialTheme: 'default',
  },
})
